// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '',
  useServiceWorker: true,
  useOffers: true,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,
  useFeedbackPrompt: false,

  searchApi: '',
  searchApiKey: '',

  // Configuration of content
  localeLanguage: 'en',
  localeDir: 'ltr',
  localeAlternatives: 'ar:العربية, en:English, es:Español, fr:Français, *:Other...',
  localeAlternativesExplanation: '* Translations via Google Translate',
  appName: '',
  appLogoUrl: '',
  mainPageHeader: '',
  mainPageIntroduction: '\n \n',
  mainPageNotification: '',
  pageAbout: '\n',
  pagePrivacy: '\n',
  mainFooter: '**Helpful Information**  \n \n',
  errorHeader: 'Data Unavailable',
  errorMessage: 'Reach out to us at: ',
  errorContactUrl: 'https://github.com/redcrossorgua/help-hia',
  errorRetry: 'Try again?',

  // Regions:
  regionConfig: '',
  regions: 'info',
  regionsLabels: 'Information',
  regionsSheetIds: '1xHhMWeNarAnnMB8_N2G1guygRz6_OIBlG8hxGn0UdqI',

  // Third-party tokens:
  google_sheets_api_key: 'AIzaSyBwY6yyUT2lmIQl21QM-O6H-K11xGLMQ8M',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',
  matomoConnectionString: '',
  appInsightsConnectionString: '',
};
